<template>
  <div>
    <div v-if="!isFilter">
      <div>
        <div class="q-mb-md">
          <q-btn
            icon="add"
            @click="newFormModalOpen=!newFormModalOpen"
            size="sm"
            flat
            class="no-shadow"
            color="secondary"
          >
            Add New {{ column.label | singular }}
          </q-btn>
        </div>
        <div class="flex">
          <q-btn
            :color="inputBgColor"
            text-color="primary"
            rounded
            :icon="showOptions ? 'keyboard arrow up' : 'keyboard arrow down'"
            @click="handleBrowseData"
            class="no-shadow inline-flex"
            :loading="loading"
          ></q-btn>
          <q-search
            v-model="term"
            v-if="loaded"
            placeholder=""
            hide-underline
            :color="inputBgColor"
            class="no-shadow inline-flex on-right"
            style="flex-grow: 1"
            inverted-light
            clearable
          >
            <q-autocomplete
              :minCharacters="1"
              :max-results="25"
              max-height="400px"
              @selected="selected"
              @search="search"
            ></q-autocomplete>
          </q-search>
        </div>
        <!-- CHIPS -->
        <div class="q-pa-md q-ma-sm bg-grey-1 full-width scroll" style="max-height: 200px;">
          <div
            class="row inline group"
            v-for="(item, index) in value"
            :key="item.id"
          >
            <q-chip closable square dense :color="inputBgColor" text-color="primary" icon="more_vert" @hide="handleRemove(index)" class="q-pa-xs" style="cursor: pointer" @click="handleClick(index)">
              {{ item | relationLabel(column, labelField) }}
            </q-chip>
          </div>
        </div>
        <!-- / CHIPS -->
        <!-- Explore Options -->
        <q-slide-transition>
          <div v-show="showOptions && options.length">
            <q-list
              v-if="showOptions && options.length >= 1"
              class="flat-box q-mt-md"
              striped
              multiline
            >
              <q-item
                v-for="option in options"
                :key="option.id"
                @click.native="selected(option, false)"
                link
              >
                <q-item-main>
                  <q-item-tile label>
                    {{ option | relationLabel(column, column.relation.label) }}
                  </q-item-tile>
                  <q-item-tile sublabel v-if="column.relation.subtitle">
                    {{ option | relationLabel(column, column.relation.subtitle)}}
                  </q-item-tile>
                </q-item-main>
              </q-item>
            </q-list>
            <div class="row q-mt-md">
              <div class="col-12">
                <q-pagination
                  class="text-center justify-center"
                  :value="pagination.page"
                  color="secondary"
                  :min="1"
                  :max="maxPage"
                  :max-pages="15"
                  boundary-numbers
                  boundary-links
                  @change="handlePageChange"
                />
              </div>
            </div>
          </div>
        </q-slide-transition>
        <!-- ADD NEW FORM -->
        <div v-if="addButton && template === 'form'">
          <div v-if="newFormModalOpen">
            <q-modal
              v-model="newFormModalOpen"
              content-classes="q-pa-lg"
              content-css="min-width: 70vw; max-width: 95vw"
              no-backdrop-dismiss
              no-esc-dismiss
            >
              <div class="fit">
                <q-btn flat icon="close" class="" style="top: 0; right: 0; position: relative; float: right" @click="newFormModalOpen=false">
                </q-btn>
                <div v-if="newFormModalOpen">
                  <h3 class="q-display-1 text-secondary capitalize no-margin">
                    Add New {{ column.label | singular }}
                  </h3>
                  <base-form
                    v-if="relationResource"
                    :resource="relationResource"
                    :parent-resource="parentResource"
                    :parent-resource-column="column"
                    :is-modal="true"
                    @add="handleNew"
                  >
                    <div slot="goback" class="full-width q-mt-md q-pb-lg">
                      <q-btn
                        icon="close"
                        label="Cancel / Close"
                        color="grey-6"
                        @click="newFormModalOpen=false"
                        flat
                      />
                    </div>
                  </base-form>
                </div>
              </div>
            </q-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import relationFieldsMixin from '../../mixins/relationFields'
import colorsMixin from '../../mixins/colors'

export default {
  name: 'AutoCompleteManyField',
  mixins: [relationFieldsMixin, colorsMixin],
  props: {
    value: {
      type: Array,
      default: () => []
    },
    addButton: {
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
    //
    }
  },
  methods: {
    //
  }
}
</script>
